const LedgerTable = ({ dataTransaction = {}, data = [] }) => {
  const formatPrice = (price) => {
    const absPrice = Math.abs(price || 0);
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 2,
    }).format(absPrice);
  };

  const totalDebit = data.length > 0 ? dataTransaction.total_debit : 0;
  const totalKredit = data.length > 0 ? dataTransaction.total_credit : 0;
  const openingSaldo = data.length > 0 ? dataTransaction.opening_balance : 0;
  const allTransactions = data;

  // Get normal balance from first transaction (all transactions in same account have same normal_balance)
  const normalBalance = data.length > 0 ? data[0].normal_balance : "DEBIT";
  let runningSaldo = openingSaldo;

  return (
    <div className="w-full">
      <table className="w-full overflow-x-auto border border-collapse text-sm">
        <thead className="bg-blue-900 text-white">
          <tr>
            <th className="p-2 border">No</th>
            <th className="p-2 border">Tanggal</th>
            <th className="p-2 border">No Slip</th>
            <th className="p-2 border">Perkiraan</th>
            <th className="p-2 border">Keterangan</th>
            <th className="p-2 border">Debet</th>
            <th className="p-2 border">Kredit</th>
            <th className="p-2 border">Saldo</th>
            <th className="p-2 border">Nama</th>
            <th className="p-2 border">No Agt</th>
            <th className="p-2 border">Norek</th>
            <th className="p-2 border">Muid</th>
            <th className="p-2 border">Opr</th>
          </tr>
        </thead>
        <tbody>
          {/* SALDO AWAL */}
          <tr className="bg-gray-100 font-bold">
            <td colSpan={7} className="p-2 text-center border">
              SALDO AWAL
            </td>
            <td className="p-2 border text-right">{formatPrice(openingSaldo)}</td>
            <td colSpan={5}></td>
          </tr>

          {/* DATA TRANSAKSI */}
          {allTransactions.length > 0 ? (
            allTransactions.map((trx, idx) => {
              // Calculate running saldo based on account's normal balance
              if (normalBalance === "DEBIT") {
                runningSaldo += (trx.debit_amount || 0) - (trx.credit_amount || 0);
              } else {
                runningSaldo += (trx.credit_amount || 0) - (trx.debit_amount || 0);
              }

              return (
                <tr key={idx}>
                  <td className="p-2 border text-center">{idx + 1}</td>
                  <td className="p-2 border text-center">
                    {new Date(trx.transaction_date).toLocaleDateString("id-ID")}
                  </td>
                  <td className="p-2 border text-center">{trx.journal_number || "-"}</td>
                  <td className="p-2 border">{`${trx.account_code} ${trx.account_name}`}</td>
                  <td className="p-2 border">{trx.journal_description || "-"}</td>
                  <td className="p-2 border text-right">{formatPrice(trx.debit_amount)}</td>
                  <td className="p-2 border text-right">{formatPrice(trx.credit_amount)}</td>
                  <td className="p-2 border text-right">{formatPrice(runningSaldo)}</td>
                  <td className="p-2 border">{trx.member_name || "-"}</td>
                  <td className="p-2 border">{trx.member_number || "-"}</td>
                  <td className="p-2 border">{trx.account_number || "-"}</td>
                  <td className="p-2 border">{trx.reference_type || "-"}</td>
                  <td className="p-2 border">{trx.created_by_operator || "-"}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={13} className="p-2 border text-center">
                Tidak Ada Data
              </td>
            </tr>
          )}

          {/* TOTAL */}
          <tr className="bg-gray-100 font-bold">
            <td colSpan={5} className="p-2 border text-center">
              Total
            </td>
            <td className="p-2 border text-right">{formatPrice(totalDebit)}</td>
            <td className="p-2 border text-right">{formatPrice(totalKredit)}</td>
            <td className="p-2 border text-right whitespace-nowrap">{formatPrice(runningSaldo)}</td>
            <td colSpan={5}></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default LedgerTable;
